export default {
  get_all: { method: 'get', url: 'api/measures' },
  show: { method: 'get', url: 'api/measures{/id}' },
  store: { method: 'post', url: 'api/measures' },
  update: { method: 'put', url: 'api/measures{/id}' },
  delete: { method: 'delete', url: 'api/measures{/id}' },
  chart_data: { method: 'get', url: 'api/measures/chart-data{/id}' },
}
